var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66547V20C18.2338 20 16.5399 19.2977 15.2911 18.0477C14.0422 16.7977 13.3406 15.1023 13.3406 13.3345V6.66547H6.65944V13.3345H13.3225C13.282 15.0759 12.5624 16.7323 11.3175 17.9496C10.0727 19.1668 8.40153 19.8483 6.66125 19.8483C4.92097 19.8483 3.24974 19.1668 2.00493 17.9496C0.76012 16.7323 0.0405238 15.0759 0 13.3345V6.66547C0 4.89768 0.701614 3.2023 1.9505 1.95228C3.19939 0.702271 4.89325 2.45335e-05 6.65944 2.45335e-05H13.3225C14.1985 -0.00235431 15.0664 0.168285 15.8765 0.502189C16.6865 0.836094 17.4228 1.3267 18.0431 1.94588C18.6634 2.56506 19.1556 3.30065 19.4914 4.11052C19.8272 4.92039 20 5.78863 20 6.66547Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.194cb6630cc943e23230f2325969113d.svg";
export { ForwardRef as ReactComponent };